import Swiper, { Navigation, Autoplay } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils';

const projectSlider = document.querySelector('.our-projects__slider');

if (projectSlider) {
  const projectSlides = projectSlider.querySelectorAll('.swiper-slide');
  const projectSwiper = new Swiper(projectSlider, {
    slidesPerView: 1,
    spaceBetween: 40,
    loop: projectSlides.length > 4 ? true : false,
    loopedSlides: projectSlides.length > 4 ? (projectSlides.length * 2) : false,
    grabCursor: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    navigation: {
      prevEl: '.our-projects__slider-btn.prev',
      nextEl: '.our-projects__slider-btn.next',
    },
    breakpoints: {
      550: {
        slidesPerView: 2,
        spaceBetween: 16,
      },

      768: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
    },
    modules: [Navigation, Autoplay],
  });

  swiperObserver(projectSwiper);
}

const testimonialsSlider = document.querySelector('.testimonials__slider');

if (testimonialsSlider) {
  const testimonialsSlides = testimonialsSlider.querySelectorAll('.swiper-slide');
  const testimonialsSwiper = new Swiper(testimonialsSlider, {
    slidesPerView: 1,
    spaceBetween: 8,
    centeredSlides: true,
    loop: testimonialsSlides.length > 4 ? true : false,
    loopedSlides: testimonialsSlides.length > 4 ? (testimonialsSlides.length * 2) : false,
    grabCursor: true,
    // autoplay: {
    //   delay: 2500,
    //   disableOnInteraction: false,
    //   pauseOnMouseEnter: true,
    // },
    navigation: {
      prevEl: '.testimonials__slider-btn.prev',
      nextEl: '.testimonials__slider-btn.next',
    },
    breakpoints: {
      650: {
        spaceBetween: 40,
      },
    },
    modules: [Navigation, Autoplay],
  });

  // swiperObserver(testimonialsSwiper);
}
